import { useEffect } from 'react'

import { App } from 'antd'

import { DesignSystemProvider } from '../../theme/Provider'

import { registerMessageBridge } from './messageBridge'
import { useStyles } from './styles'

const MessageRegistrarInner: React.FC = () => {
  const { message } = App.useApp()
  const { styles } = useStyles()

  useEffect(() => {
    registerMessageBridge({ message, styles })
  }, [message, styles])

  return null
}

export const DesignSystemMessageRegistrar: React.FC = () => (
  <DesignSystemProvider>
    <MessageRegistrarInner />
  </DesignSystemProvider>
)
